import { createActions } from 'redux-actions';

export default createActions(
  {
    SHOW: () => ({}),
    HIDE: () => ({}),
  },
  { prefix: 'MAP3D' },
);
